// extracted by mini-css-extract-plugin
export default {"checkbox":"UserProfileAdministrationRemoveAdminConfirmContainer_checkbox__WQNW7"};